var cov_b4seqnr8a = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Pagination/PageSizeList.tsx",
      hash = "c83ef073fcda0d9f915335387fdf672b474d7a33",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Pagination/PageSizeList.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 16
        }
      },
      "2": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 52
        }
      },
      "3": {
        start: {
          line: 21,
          column: 34
        },
        end: {
          line: 21,
          column: 44
        }
      },
      "4": {
        start: {
          line: 22,
          column: 18
        },
        end: {
          line: 22,
          column: 57
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 51
        }
      },
      "6": {
        start: {
          line: 28,
          column: 109
        },
        end: {
          line: 28,
          column: 119
        }
      },
      "7": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 44,
          column: 5
        }
      },
      "8": {
        start: {
          line: 41,
          column: 25
        },
        end: {
          line: 41,
          column: 50
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 14,
            column: 40
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 33
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 11
          },
          end: {
            line: 45,
            column: 3
          }
        },
        line: 27
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 41,
            column: 20
          },
          end: {
            line: 41,
            column: 21
          }
        },
        loc: {
          start: {
            line: 41,
            column: 25
          },
          end: {
            line: 41,
            column: 50
          }
        },
        line: 41
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 22
          },
          end: {
            line: 28,
            column: 62
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 28,
            column: 37
          },
          end: {
            line: 28,
            column: 62
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 86
          },
          end: {
            line: 28,
            column: 104
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 28,
            column: 102
          },
          end: {
            line: 28,
            column: 104
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 33
          },
          end: {
            line: 41,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 33
          },
          end: {
            line: 41,
            column: 42
          }
        }, {
          start: {
            line: 41,
            column: 46
          },
          end: {
            line: 41,
            column: 48
          }
        }],
        line: 41
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Pagination/PageSizeList.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Select from '../Select';
import { paginationClass } from './styles';
import { getDirectionClass } from '../utils/classname';
var DefaultValue = (cov_b4seqnr8a.s[0]++, {
  pageSizeList: [10, 20, 30, 50, 100]
});

var PageSizeList =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PageSizeList, _PureComponent);

  var _super = _createSuper2(PageSizeList);

  function PageSizeList(props) {
    var _this;

    _classCallCheck(this, PageSizeList);

    cov_b4seqnr8a.f[0]++;
    cov_b4seqnr8a.s[1]++;
    _this = _super.call(this, props);
    cov_b4seqnr8a.s[2]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PageSizeList, [{
    key: "handleChange",
    value: function handleChange(pageSize) {
      cov_b4seqnr8a.f[1]++;

      var _ref = (cov_b4seqnr8a.s[3]++, this.props),
          current = _ref.current,
          onChange = _ref.onChange;

      var start = (cov_b4seqnr8a.s[4]++, (current - 1) * this.props.pageSize + 1);
      cov_b4seqnr8a.s[5]++;
      onChange(Math.ceil(start / pageSize), pageSize);
    }
  }, {
    key: "render",
    value: function render() {
      cov_b4seqnr8a.f[2]++;

      var _ref2 = (cov_b4seqnr8a.s[6]++, this.props),
          pageSize = _ref2.pageSize,
          _ref2$pageSizeList = _ref2.pageSizeList,
          pageSizeList = _ref2$pageSizeList === void 0 ? (cov_b4seqnr8a.b[0][0]++, DefaultValue.pageSizeList) : _ref2$pageSizeList,
          text = _ref2.text,
          disabled = _ref2.disabled,
          size = _ref2.size,
          _ref2$sizeListProps = _ref2.sizeListProps,
          sizeListProps = _ref2$sizeListProps === void 0 ? (cov_b4seqnr8a.b[1][0]++, {}) : _ref2$sizeListProps;

      cov_b4seqnr8a.s[7]++;
      return (
        /*#__PURE__*/
        React.createElement(Select, Object.assign({
          onChange: this.handleChange,
          disabled: disabled,
          absolute: true,
          autoAdapt: true,
          keygen: true,
          value: pageSize,
          size: size,
          className: paginationClass(getDirectionClass('section'), 'pagesize'),
          data: pageSizeList,
          renderItem: function renderItem(d) {
            cov_b4seqnr8a.f[3]++;
            cov_b4seqnr8a.s[8]++;
            return "".concat(d, " ").concat((cov_b4seqnr8a.b[2][0]++, text.page) || (cov_b4seqnr8a.b[2][1]++, ''));
          }
        }, sizeListProps, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 31,
            columnNumber: 7
          }
        }))
      );
    }
  }]);

  return PageSizeList;
}(PureComponent);

PageSizeList.defaultProps = DefaultValue;
export default PageSizeList;